<script setup lang="ts">
import { resolveComponent } from 'vue';
import type { BagVariant } from '@pkg/sanity-utils/types/bag';
import type { CmsIconName } from '@pkg/cms-icons';
import CmsIcon from '../../inner/Tiles/CmsIcon.vue';
import TitleBlock from '../../inner/Title/TitleBlock.vue';

interface SubBlock {
  title?: string,
  icon?: CmsIconName,
}

interface Props {
  variant?: BagVariant,
  title?: {
    title?: string,
    preTitle?: string,
  },
  upperLeftBlock?: SubBlock,
  upperRightBlock?: SubBlock,
  lowerLeftBlock?: SubBlock,
  lowerRightBlock?: SubBlock,
}

defineProps<Props>();

/** Host app registers PartialBag. */
const PartialBag = resolveComponent('PartialBag');
</script>

<template>
  <component
    :is="PartialBag"
    :title="title ?? {}"
    :variant="variant"
  >
    <template #upperLeftBlock>
      <CmsIcon v-if="upperLeftBlock?.icon" :name="upperLeftBlock?.icon" class="c-bag-block__icon" />
      <TitleBlock
        :title="upperLeftBlock?.title"
        size="tiny"
        tag="h3"
      />
    </template>

    <template #lowerLeftBlock>
      <CmsIcon v-if="lowerLeftBlock?.icon" :name="lowerLeftBlock?.icon" class="c-bag-block__icon" />
      <TitleBlock
        :title="lowerLeftBlock?.title"
        size="tiny"
        tag="h3"
      />
    </template>

    <template #upperRightBlock>
      <CmsIcon v-if="upperRightBlock?.icon" :name="upperRightBlock?.icon" class="c-bag-block__icon" />
      <TitleBlock
        :title="upperRightBlock?.title"
        size="tiny"
        tag="h3"
      />
    </template>

    <template #lowerRightBlock>
      <CmsIcon v-if="lowerRightBlock?.icon" :name="lowerRightBlock?.icon" class="c-bag-block__icon" />
      <TitleBlock
        :title="lowerRightBlock?.title"
        size="tiny"
        tag="h3"
      />
    </template>
  </component>
</template>

<style scoped>
.c-bag-block__icon {
  font-size: 2rem;

  @screen tablet-wide {
    font-size: 3rem;
  }
}
</style>
